import { render, staticRenderFns } from "./JoLoadMore.vue?vue&type=template&id=4894e192&scoped=true&"
import script from "./JoLoadMore.vue?vue&type=script&lang=js&"
export * from "./JoLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./JoLoadMore.vue?vue&type=style&index=0&id=4894e192&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894e192",
  null
  
)

export default component.exports